<template>
  <div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import Config from '@/config'
import recaptchaV3Service from '@/services/recaptcha-v3'
import Util from '@/util'

export default {

  data() {
    return {
      isCanloadRecaptcha: false,
    }
  },

  computed: {
  },

  async created() {
    this.keyRecaptcha = Config.keyRecapcha
    try {
      this.isCanloadRecaptcha = true
      this.getTokenCaptcharV3()
    } catch (error) {
      this.isCanloadRecaptcha = true
      Sentry.captureException(new Error('Load unleash login error'), {
        extra: {
          error,
        },
      })
    }
  },

  methods: {
    async getTokenCaptcharV3() {
      try {
        const response = await recaptchaV3Service.executeRecaptcha('demo_mode')
        this.onVerify(response)

        Util.trackGA4AndMixpanel(
          'Demo Mode Captchar',
          'reCAPTCHA v3 verified',
        )
      } catch (error) {
        this.onRecaptchaError()
        Sentry.captureException(new Error('Presenter login with reCAPTCHA v3 error'), {
          extra: { error: error.message },
        })
      }
    },

    onVerify(response) {
      this.$emit('success', response)
    },
    onRender() {
      this.$emit('render')
    },

    onRecaptchaError() {
      this.$emit('error')
    },
  },
}
</script>
